<template>
  <div class="payment-request-action-column">
    <WdsMenu z-index="1000" placement="bottom-end">
      <template #trigger>
        <WdsButtonGhost :label="$t('More options')" data-test="payment-request-actions-menu">
          <WdsIcon name="overflow-menu-horizontal" />
        </WdsButtonGhost>
      </template>

      <WdsMenuOption data-test="see-worker-details-option" @click="seeWorkerDetails">
        <WdsStack direction-row align-center gap-sm>
          <WdsIcon name="person" :size="16" />
          {{ $t('See worker details') }}
        </WdsStack>
      </WdsMenuOption>
    </WdsMenu>
  </div>
</template>

<script lang="ts" setup>
import { WdsButtonGhost, WdsIcon, WdsMenu, WdsMenuOption, WdsStack } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'
import { FragmentType, graphql, useFragment } from '@/gql'

const { openPartnerWorkerDetailPanel } = useTablePanels()

const PaymentRequestActionColumnPayrolled = graphql(`
  fragment PaymentRequestActionColumnPayrolled on PaymentRequest {
    worker {
      id
    }
    hire {
      employment {
        id
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestActionColumnPayrolled>
}>()

const column = computed(() => useFragment(PaymentRequestActionColumnPayrolled, props.row))

const seeWorkerDetails = () => {
  openPartnerWorkerDetailPanel({
    workerId: column.value.worker.id,
    employmentId: column.value.hire?.employment?.id,
  })
}
</script>

<style scoped lang="scss">
.payment-request-action-column {
  :deep(.wds-menu) {
    width: max-content;
  }
}
</style>
